var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex", attrs: { id: `question_${_vm.index + 1}` } },
    [
      _c(
        "span",
        {
          staticClass:
            "w-12 py-2 px-4 text-3xl leading-relaxed absolute lg:w-20 lg:py-4 lg:px-6",
          class: {
            "bg-exam-mark-correct": _vm.correct === "correct",
            "bg-exam-mark-wrong": _vm.correct === "wrong",
            "bg-exam-mark-part": _vm.correct === "part",
          },
        },
        [_vm._v(_vm._s(_vm.index + 1))]
      ),
      _c(
        "div",
        {
          class: [
            "min-w-0 py-3 flex-1 lg:pl-20 lg:py-5",
            [_vm.isMobile ? "pl-20" : "pl-14"],
          ],
        },
        [
          [
            _c(
              "div",
              { staticClass: "-ml-20 pl-20 flex items-center gap-x-1" },
              [
                _vm.isCreate || _vm.isCopy
                  ? _c("div", {
                      staticClass:
                        "handleQuestion w-10 h-10 my-5 bg-drag flex justify-center items-center absolute -left-5 box-content cursor-grab transform -translate-y-1",
                    })
                  : _vm._e(),
                _c("GrmTextField", {
                  staticClass: "min-w-0 flex-1",
                  attrs: {
                    placeholder: _vm.isMobile
                      ? _vm.$t("testBank.alert.shortName")
                      : _vm.$t("testBank.alert.name"),
                    disabled: _vm.isView,
                  },
                  model: {
                    value: _vm.question.questionTitle,
                    callback: function ($$v) {
                      _vm.$set(_vm.question, "questionTitle", $$v)
                    },
                    expression: "question.questionTitle",
                  },
                }),
                _vm.testbankObj.examType === "QUIZ"
                  ? _c(
                      "div",
                      { staticClass: "flex items-center gap-x-1" },
                      [
                        _c("GrmTextField", {
                          staticClass: "w-20",
                          attrs: {
                            type: "number",
                            placeholder: "1",
                            min: 1,
                            max: 100,
                            disabled: !_vm.isCreate && !_vm.isCopy,
                          },
                          model: {
                            value: _vm.question.questionScore,
                            callback: function ($$v) {
                              _vm.$set(_vm.question, "questionScore", $$v)
                            },
                            expression: "question.questionScore",
                          },
                        }),
                        _c("span", { staticClass: "text-xs" }, [
                          _vm._v(_vm._s(_vm.$t("exam.question.point"))),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.isCreate || _vm.isCopy
                  ? _c(
                      "div",
                      [
                        _c(
                          "GrmBtn",
                          {
                            attrs: { size: "xs", color: "red" },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("deleteQuestion", _vm.question)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.delete")))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          _vm.testbankObj.examType === "QUIZ" ||
          _vm.testbankExam.examType === "QUIZ"
            ? _c(
                "div",
                { staticClass: "mt-2 flex flex-col gap-y-2" },
                [
                  _vm._l(_vm.question.answerList, function (answer, i) {
                    return _c(
                      "div",
                      { key: i, staticClass: "flex items-start gap-x-1" },
                      [
                        _c("GrmTextarea", {
                          staticClass: "min-w-0 flex-1",
                          attrs: {
                            color: "blue",
                            disabled: !_vm.isCreate && !_vm.isCopy,
                            placeholder: _vm.$t("exam.question.placeholder"),
                          },
                          model: {
                            value: answer.answerText,
                            callback: function ($$v) {
                              _vm.$set(answer, "answerText", $$v)
                            },
                            expression: "answer.answerText",
                          },
                        }),
                        _vm.isCreate || _vm.isCopy
                          ? _c(
                              "GrmBtn",
                              {
                                attrs: { size: "xs", color: "red" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onDeleteAnswer(answer)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("common.delete")))]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  _vm.correct === "wrong"
                    ? _c(
                        "div",
                        { staticClass: "flex items-start" },
                        [
                          _c("GrmTextarea", {
                            attrs: { disabled: "", value: "", color: "red" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isCreate || _vm.isCopy
                    ? _c("GrmBtn", { on: { click: _vm.onAddAnswer } }, [
                        _vm._v(_vm._s(_vm.$t("testBank.add.answer"))),
                      ])
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }